import { render, staticRenderFns } from "./SessionPresentationCard.vue?vue&type=template&id=72be6835&scoped=true"
import script from "./SessionPresentationCard.vue?vue&type=script&lang=js"
export * from "./SessionPresentationCard.vue?vue&type=script&lang=js"
import style0 from "./SessionPresentationCard.vue?vue&type=style&index=0&id=72be6835&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be6835",
  null
  
)

export default component.exports